<template>
    <div id="allocateWater" :class="{'not-mobile':!isMobile}">
        <template v-if="isMobile">
            <transition name="sider-fade">
                <Mpage-side class="index-sider" v-show="isOpen">
                </Mpage-side>
            </transition>
        </template>
        <template v-else >
        <page-head></page-head>
        <transition name="sider-fade">
            <page-side class="index-sider" style="position:fixed;" v-show="isOpen">
            </page-side>
        </transition>
        </template>


        <div id="main-router" class="index-content" :class="{'index-content-open':!isOpen,}">
            <!-- <transition :duration="{ enter: 100, leave: 100 }" name="fade1"> -->
            <router-view></router-view>
            <!-- </transition> -->
        </div>

        <page-footer id="main-footer" class="index-content" :class="{'index-content-open':!isOpen}"></page-footer>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import LS from '../../lib/LSstore'

    import MpageHead from '../../components/tempControl/MpageHead.vue'
    import pageFooter from '../../components/tempControl/pageFooter.vue'
    import MpageSide from '../../components/tempControl/MpageSide.vue'
    import pageHead from '../../components/tempControl/pageHead.vue'
    import pageSide from '../../components/tempControl/pageSide.vue'

    export default {
        name: 'dashboard',
        components: {
            pageHead,
            pageFooter,
            pageSide,
            MpageHead,
            MpageSide,
        },
        data() {
            return {
                showMe: true
            }
        },
        computed: {
            isLoading() {
                return this.$store.state.isLoading
            },
            isMobile() {
                return this.$store.state.isMobile

            },
            isOpen() {
                return this.$store.state.siderbarOpen
            }
        },
        created() {
            //检测是否需要重载state 数据
            const userInfo = LS.getItem("userInfo");
            const deviceInfo = LS.getItem("deviceInfo");
            const deviceListType = LS.getItem("deviceListType");

            if (userInfo) {
                this.$store.dispatch("setUserInfo", userInfo);

            }
            if (deviceInfo) {
                this.$store.dispatch("setDeviceInfo", deviceInfo);
            }
            if (deviceListType) {
                this.$store.dispatch("setDeviceListType", deviceListType);
            }

        },
        mounted() {
        },


        methods: {
            clickMobileMask() {
                this.$store.dispatch('toggleSide')
            }


        }
    }
</script>

<style scoped>
    #allocateWater {
        background: #eeeff2;
        display: flex;
        min-height: 100vh;
        flex-direction: column;
    }

    /*侧边栏动画 */
    .sider-fade-enter-active {
        transition: all .3s;
    }

    .sider-fade-leave-active {
        transition: all .3s;
    }

    .sider-fade-enter {
        left: -240px;
        opacity: 0;
    }

    .sider-fade-leave-to {
        left: -240px;
        opacity: 0;
    }

    /*渐变*/

    .fade1-enter-active,
    .fade1-leave-active {
        transition: opacity 0.3s
    }

    .fade1-enter-to,
    .fade1-leave-to {
        opacity: 0;
    }

    .index-sider {
        display: flex;
        top: 0px;
        left: 0;
        width: 250px;
        height: 100%;
    }


    .css-shadow-right {
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .2), 0 0 6px 0 rgba(0, 0, 0, .1)
    }

    .css-margin-top {
        margin: 20px 0
    }

    /* 页面区 通用css */

    .not-mobile #main-router{
        margin-top: 120px;
    }
    .not-mobile #main-footer{
        position: fixed;
        bottom: 0;
    }

    .index-content {
        margin-left: 280px;
        margin-right: 20px;
        margin-top: 60px;
        transition: margin .15s;
        flex: 1;
    }

    .index-content-open {
        margin-left: 40px;
    }

    .charts-input {
        max-width: 100px
    }

    .chars-title {
        text-align: center
    }

    .chars-header {
        display: flex;
        justify-content: space-between;
        align-items: center
    }
    .charts-input{
        padding: 0;
    }

    @media screen and (max-width: 900px) {
        .index-content {
            margin: 0px 10px 70px 10px;
            max-width: 100%;
            position: relative;
        }

        .index-sider {
            width: 100%;
            height: 50px;
        }

        .mobile-mask {
            width: 100%;
            height: 100%;
            position: fixed;
            top: 50px;
            left: 0;
            background: rgba(0, 0, 0, .3);
            z-index: 5;
        }
    }
</style>
<style>
    #allocateWater .set-option{}
</style>





// WEBPACK FOOTER //
// index.vue?4ad96180